export const directFlights = [

  // v2 Destinations
  // {
  //   dep_code: "LON",
  //   des_code: "ANU ;10430",
  // },
  {
    dep_code: "LON",
    des_code: "NAS ;31302",
  },
  {
    dep_code: "LON",
    des_code: "BGI ;10785",
  },
  {
    dep_code: "LON",
    des_code: "BDA ;10714",
  },
  {
    dep_code: "LON",
    des_code: "GND ;12549",
  },
  // {
  //   dep_code: "LON",
  //   des_code: "MBJ ;31636",
  // },
  {
    dep_code: "LON",
    des_code: "CUN ;11623",
  },
  {
    dep_code: "LON",
    des_code: "SKB ;16943",
  },
  {
    // dep_code: "LON",
    // des_code: "UVF ;16984",
  },
  {
    dep_code: "LON",
    des_code: "TAB ;17311",
  },
  {
    dep_code: "LON",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "LGW",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "LHR",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "STN",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "MAN",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "BHX",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "NCL",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "GLA",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "LON",
    des_code: "AUH ;10559",
  },
  {
    dep_code: "MAN",
    des_code: "AUH ;10559",
  },
  {
    dep_code: "LON",
    des_code: "MCT ;14327",
  },
  {
    dep_code: "LON",
    des_code: "DOH ;11866",
  },
  {
    dep_code: "MAN",
    des_code: "DOH ;11866",
  },
  {
    dep_code: "BHX",
    des_code: "DOH ;11866",
  },

  // V3 Destinations
  // LON
  {
    dep_code: "LON",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "LON",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "LON",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "LON",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "LON",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "LON",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "LON",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "LON",
    des_code: "FAO ;12196",
  },
  {
    dep_code: "LON",
    des_code: "FLR ;12270",
  },
  {
    dep_code: "LON",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "LON",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "LON",
    des_code: "LPA ;14104",
  },
  {
    dep_code: "LON",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "LON",
    des_code: "IBZ ;12987",
  },
  {
    dep_code: "LON",
    des_code: "KGS ;13484",
  },
  {
    dep_code: "LON",
    des_code: "ACE ;10218",
  },
  {
    dep_code: "LON",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "LON",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "LON",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "LON",
    des_code: "RAK ;16429",
  },
  {
    dep_code: "LON",
    des_code: "MAH ;14267",
  },
  {
    dep_code: "LON",
    des_code: "MXP ;14456",
  },
  {
    dep_code: "LON",
    des_code: "JMK ;13294",
  },
  {
    dep_code: "LON",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "LON",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "LON",
    des_code: "PFO ;15508",
  },
  {
    dep_code: "LON",
    des_code: "PUY ;15820",
  },
  {
    dep_code: "LON",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "LON",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "LON",
    des_code: "JTR ;32620",
  },
  {
    dep_code: "LON",
    des_code: "SPU ;17080",
  },
  {
    dep_code: "LON",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "LON",
    des_code: "VCE ;17968",
  },
  {
    dep_code: "LON",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "LON",
    des_code: "ZTH ;19290",
  },
  //LGW
  {
    dep_code: "LGW",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "LGW",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "LGW",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "LGW",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "LGW",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "LGW",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "LGW",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "LGW",
    des_code: "FAO ;12196",
  },
  {
    dep_code: "LGW",
    des_code: "FLR ;12270",
  },
  {
    dep_code: "LGW",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "LGW",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "LGW",
    des_code: "LPA ;14104",
  },
  {
    dep_code: "LGW",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "LGW",
    des_code: "IBZ ;12987",
  },
  {
    dep_code: "LGW",
    des_code: "KGS ;13484",
  },
  {
    dep_code: "LGW",
    des_code: "ACE ;10218",
  },
  {
    dep_code: "LGW",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "LGW",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "LGW",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "LGW",
    des_code: "RAK ;16429",
  },
  {
    dep_code: "LGW",
    des_code: "MAH ;14267",
  },
  {
    dep_code: "LGW",
    des_code: "MXP ;14456",
  },
  {
    dep_code: "LGW",
    des_code: "JMK ;13294",
  },
  {
    dep_code: "LGW",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "LGW",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "LGW",
    des_code: "PFO ;15508",
  },
  {
    dep_code: "LGW",
    des_code: "PUY ;15820",
  },
  {
    dep_code: "LGW",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "LGW",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "LGW",
    des_code: "JTR ;32620",
  },
  {
    dep_code: "LGW",
    des_code: "SPU ;17080",
  },
  {
    dep_code: "LGW",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "LGW",
    des_code: "VCE ;17968",
  },
  {
    dep_code: "LGW",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "LGW",
    des_code: "ZTH ;19290",
  },
  // {
  //   dep_code: "LGW",
  //   des_code: "ADB ;13205",
  // },
  //LHR
  // {
  //   dep_code: "LHR",
  //   des_code: "AGA ;10271",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "LHR",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "LHR",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "LHR",
  //   des_code: "DLM ;11828",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "DBV ;11739",
  // },
  {
    dep_code: "LHR",
    des_code: "FAO ;12196",
  },
  {
    dep_code: "LHR",
    des_code: "FLR ;12270",
  },
  // {
  //   dep_code: "LHR",
  //   des_code: "FUE ;12354",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "FNC ;12286",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "LPA ;14104",
  // },
  {
    dep_code: "LHR",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "LHR",
    des_code: "IBZ ;12987",
  },
  // {
  //   dep_code: "LHR",
  //   des_code: "KGS ;13484",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "ACE ;10218",
  // },
  {
    dep_code: "LHR",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "LHR",
    des_code: "AGP ;10284",
  },
  // {
  //   dep_code: "LHR",
  //   des_code: "MLA ;14516",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "RAK ;16429",
  // },
  // {
  //   dep_code: "LHR",
  //   des_code: "MAH ;14267",
  // },
  {
    dep_code: "LHR",
    des_code: "MXP ;14456",
  },
  {
    dep_code: "LHR",
    des_code: "JMK ;13294",
  },
  {
    dep_code: "LHR",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "LHR",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "LHR",
    des_code: "PFO ;15508",
  },
  {
    dep_code: "LHR",
    des_code: "PUY ;15820",
  },
  {
    dep_code: "LHR",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "LHR",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "LHR",
    des_code: "JTR ;32620",
  },
  {
    dep_code: "LHR",
    des_code: "SPU ;17080",
  },
  {
    dep_code: "LHR",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "LHR",
    des_code: "VCE ;17968",
  },
  // {
  //   dep_code: "LHR",
  //   des_code: "VRN ;18074",
  // },
  {
    dep_code: "LHR",
    des_code: "ZTH ;19290",
  },

  // STN
  {
    dep_code: "STN",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "STN",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "STN",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "STN",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "STN",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "STN",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "STN",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "STN",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "STN",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "STN",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "STN",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "STN",
    des_code: "LPA ;14104",
  },
  {
    dep_code: "STN",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "STN",
    des_code: "IBZ ;12987",
  },
  {
    dep_code: "STN",
    des_code: "KGS ;13484",
  },
  {
    dep_code: "STN",
    des_code: "ACE ;10218",
  },
  {
    dep_code: "STN",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "STN",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "STN",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "STN",
    des_code: "RAK ;16429",
  },
  {
    dep_code: "STN",
    des_code: "MAH ;14267",
  },
  {
    dep_code: "STN",
    des_code: "MXP ;14456",
  },
  // {
  //   dep_code: "STN",
  //   des_code: "JMK ;13294",
  // },
  {
    dep_code: "STN",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "STN",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "STN",
    des_code: "PFO ;15508",
  },
  {
    dep_code: "STN",
    des_code: "PUY ;15820",
  },
  {
    dep_code: "STN",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "STN",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "STN",
    des_code: "JTR ;32620",
  },
  {
    dep_code: "STN",
    des_code: "SPU ;17080",
  },
  {
    dep_code: "STN",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "STN",
    des_code: "VCE ;17968",
  },
  {
    dep_code: "STN",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "STN",
    des_code: "ZTH ;19290",
  },
  // {
  //   dep_code: "STN",
  //   des_code: "ADB ;13205",
  // },

  // MAN
  {
    dep_code: "MAN",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "MAN",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "MAN",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "MAN",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "MAN",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "MAN",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "MAN",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "MAN",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "MAN",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "MAN",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "MAN",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "MAN",
    des_code: "LPA ;14104",
  },
  {
    dep_code: "MAN",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "MAN",
    des_code: "IBZ ;12987",
  },
  {
    dep_code: "MAN",
    des_code: "KGS ;13484",
  },
  {
    dep_code: "MAN",
    des_code: "ACE ;10218",
  },
  {
    dep_code: "MAN",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "MAN",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "MAN",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "MAN",
    des_code: "RAK ;16429",
  },
  {
    dep_code: "MAN",
    des_code: "MAH ;14267",
  },
  {
    dep_code: "MAN",
    des_code: "MXP ;14456",
  },
  // {
  //   dep_code: "MAN",
  //   des_code: "JMK ;13294",
  // },
  {
    dep_code: "MAN",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "MAN",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "MAN",
    des_code: "PFO ;15508",
  },
  {
    dep_code: "MAN",
    des_code: "PUY ;15820",
  },
  {
    dep_code: "MAN",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "MAN",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "MAN",
    des_code: "JTR ;32620",
  },
  {
    dep_code: "MAN",
    des_code: "SPU ;17080",
  },
  {
    dep_code: "MAN",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "MAN",
    des_code: "VCE ;17968",
  },
  {
    dep_code: "MAN",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "MAN",
    des_code: "ZTH ;19290",
  },
  // {
  //   dep_code: "MAN",
  //   des_code: "ADB ;13205",
  // },

  // BHX
  {
    dep_code: "BHX",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "BHX",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "BHX",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "BHX",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "BHX",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "BHX",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "BHX",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "BHX",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "BHX",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "BHX",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "BHX",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "BHX",
    des_code: "LPA ;14104",
  },
  {
    dep_code: "BHX",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "BHX",
    des_code: "IBZ ;12987",
  },
  {
    dep_code: "BHX",
    des_code: "KGS ;13484",
  },
  {
    dep_code: "BHX",
    des_code: "ACE ;10218",
  },
  {
    dep_code: "BHX",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "BHX",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "BHX",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "BHX",
    des_code: "RAK ;16429",
  },
  // {
  //   dep_code: "BHX",
  //   des_code: "MAH ;14267",
  // },
  // {
  //   dep_code: "BHX",
  //   des_code: "MXP ;14456",
  // },
  {
    dep_code: "BHX",
    des_code: "JMK ;13294",
  },
  {
    dep_code: "BHX",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "BHX",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "BHX",
    des_code: "PFO ;15508",
  },
  {
    dep_code: "BHX",
    des_code: "PUY ;15820",
  },
  {
    dep_code: "BHX",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "BHX",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "BHX",
    des_code: "JTR ;32620",
  },
  {
    dep_code: "BHX",
    des_code: "SPU ;17080",
  },
  {
    dep_code: "BHX",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "BHX",
    des_code: "VCE ;17968",
  },
  {
    dep_code: "BHX",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "BHX",
    des_code: "ZTH ;19290",
  },
  // {
  //   dep_code: "BHX",
  //   des_code: "ADB ;13205",
  // },

  //NCL
  {
    dep_code: "NCL",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "NCL",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "NCL",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "NCL",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "NCL",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "NCL",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "NCL",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "NCL",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "NCL",
    des_code: "LPA ;14104",
  },
  {
    dep_code: "NCL",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "NCL",
    des_code: "IBZ ;12987",
  },
  {
    dep_code: "NCL",
    des_code: "KGS ;13484",
  },
  {
    dep_code: "NCL",
    des_code: "ACE ;10218",
  },
  {
    dep_code: "NCL",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "NCL",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "NCL",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "NCL",
    des_code: "RAK ;16429",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "MAH ;14267",
  // },
  // {
  //   dep_code: "NCL",
  //   des_code: "MXP ;14456",
  // },
  // {
  //   dep_code: "NCL",
  //   des_code: "JMK ;13294",
  // },
  // {
  //   dep_code: "NCL",
  //   des_code: "NAP ;14879",
  // },
  {
    dep_code: "NCL",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "NCL",
    des_code: "PFO ;15508",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "PUY ;15820",
  // },
  {
    dep_code: "NCL",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "NCL",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "NCL",
    des_code: "JTR ;32620",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "SPU ;17080",
  // },
  {
    dep_code: "NCL",
    des_code: "TFS ;17368",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "VCE ;17968",
  // },
  {
    dep_code: "NCL",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "NCL",
    des_code: "ZTH ;19290",
  },
  // {
  //   dep_code: "NCL",
  //   des_code: "ADB ;13205",
  // },
  // GLA
  {
    dep_code: "GLA",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "GLA",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "GLA",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "GLA",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "GLA",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "GLA",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "FLR ;12270",
  // },
  // {
  //   dep_code: "GLA",
  //   des_code: "FUE ;12354",
  // },
  {
    dep_code: "GLA",
    des_code: "FNC ;12286",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "LPA ;14104",
  // },
  {
    dep_code: "GLA",
    des_code: "SKG ;32614",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "IBZ ;12987",
  // },
  {
    dep_code: "GLA",
    des_code: "KGS ;13484",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "ACE ;10218",
  // },
  {
    dep_code: "GLA",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "GLA",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "GLA",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "GLA",
    des_code: "RAK ;16429",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "MAH ;14267",
  // },
  // {
  //   dep_code: "GLA",
  //   des_code: "MXP ;14456",
  // },
  // {
  //   dep_code: "GLA",
  //   des_code: "JMK ;13294",
  // },
  {
    dep_code: "GLA",
    des_code: "NAP ;14879",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "PMI ;15634",
  // },
  {
    dep_code: "GLA",
    des_code: "PFO ;15508",
  },
  {
    dep_code: "GLA",
    des_code: "PUY ;15820",
  },
  {
    dep_code: "GLA",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "GLA",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "GLA",
    des_code: "JTR ;32620",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "SPU ;17080",
  // },
  // {
  //   dep_code: "GLA",
  //   des_code: "TFS ;17368",
  // },
  // {
  //   dep_code: "GLA",
  //   des_code: "VCE ;17968",
  // },
  {
    dep_code: "GLA",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "GLA",
    des_code: "ZTH ;19290",
  },
  // {
  //   dep_code: "GLA",
  //   des_code: "ADB ;13205",
  // },

  // CWL

  // {
  //   dep_code: "CWL",
  //   des_code: "AGA ;10271",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "BJV ;11166",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "CFU ;32612",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "HER ;32613",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "DLM ;11828",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "DBV ;11739",
  // },
  {
    dep_code: "CWL",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "CWL",
  //   des_code: "FLR ;12270",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "FUE ;12354",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "FNC ;12286",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "LPA ;14104",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "SKG ;32614",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "IBZ ;12987",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "KGS ;13484",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "ACE ;10218",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "LCA ;13894",
  // },
  {
    dep_code: "CWL",
    des_code: "AGP ;10284",
  },
  // {
  //   dep_code: "CWL",
  //   des_code: "MLA ;14516",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "RAK ;16429",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "MAH ;14267",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "MXP ;14456",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "JMK ;13294",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "NAP ;14879",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "PMI ;15634",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "PFO ;15508",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "PUY ;15820",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "RHO ;16534",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "FCO ;16607",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "JTR ;32620",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "SPU ;17080",
  // },
  {
    dep_code: "CWL",
    des_code: "TFS ;17368",
  },
  // {
  //   dep_code: "CWL",
  //   des_code: "VCE ;17968",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "VRN ;18074",
  // },
  // {
  //   dep_code: "CWL",
  //   des_code: "ZTH ;19290",
  // },

  // BFS
  {
    dep_code: "BFS",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "BFS",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "BFS",
    des_code: "CFU ;32612",
  },
  {
    dep_code: "BFS",
    des_code: "HER ;32613",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "BFS",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "BFS",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "BFS",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "BFS",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "BFS",
    des_code: "LPA ;14104",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "SKG ;32614",
  // },
  {
    dep_code: "BFS",
    des_code: "IBZ ;12987",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "KGS ;13484",
  // },
  {
    dep_code: "BFS",
    des_code: "ACE ;10218",
  },
  {
    dep_code: "BFS",
    des_code: "LCA ;13894",
  },
  {
    dep_code: "BFS",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "BFS",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "BFS",
    des_code: "RAK ;16429",
  },
  {
    dep_code: "BFS",
    des_code: "MAH ;14267",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "MXP ;14456",
  // },
  // {
  //   dep_code: "BFS",
  //   des_code: "JMK ;13294",
  // },
  // {
  //   dep_code: "BFS",
  //   des_code: "NAP ;14879",
  // },
  {
    dep_code: "BFS",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "BFS",
    des_code: "PFO ;15508",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "PUY ;15820",
  // },
  {
    dep_code: "BFS",
    des_code: "RHO ;16534",
  },
  // {
  //   dep_code: "BFS",
  //   des_code: "FCO ;16607",
  // },
  // {
  //   dep_code: "BFS",
  //   des_code: "JTR ;32620",
  // },
  // {
  //   dep_code: "BFS",
  //   des_code: "SPU ;17080",
  // },
  {
    dep_code: "BFS",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "BFS",
    des_code: "VCE ;17968",
  },
  {
    dep_code: "BFS",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "BFS",
    des_code: "ZTH ;19290",
  },

];

export const directFlightsIE = [
  // v2 destinations
  {
    dep_code: "DUB",
    des_code: "AUH ;10559",
  },
  {
    dep_code: "DUB",
    des_code: "DXB ;11945",
  },
  {
    dep_code: "DUB",
    des_code: "DOH ;11866",
  },


  // v3 destinations

  //DUB
  {
    dep_code: "DUB",
    des_code: "AGA ;10271",
  },
  // {
  //   dep_code: "DUB",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "DUB",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "DUB",
    des_code: "CFU ;32612",
  },
  // {
  //   dep_code: "DUB",
  //   des_code: "HER ;32613",
  // },
  // {
  //   dep_code: "DUB",
  //   des_code: "DLM ;11828",
  // },
  {
    dep_code: "DUB",
    des_code: "DBV ;11739",
  },
  {
    dep_code: "DUB",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "DUB",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "DUB",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "DUB",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "DUB",
    des_code: "LPA ;14104",
  },
  {
    dep_code: "DUB",
    des_code: "SKG ;32614",
  },
  {
    dep_code: "DUB",
    des_code: "IBZ ;12987",
  },
  {
    dep_code: "DUB",
    des_code: "KGS ;13484",
  },
  {
    dep_code: "DUB",
    des_code: "ACE ;10218",
  },
  // {
  //   dep_code: "DUB",
  //   des_code: "LCA ;13894",
  // },
  {
    dep_code: "DUB",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "DUB",
    des_code: "MLA ;14516",
  },
  {
    dep_code: "DUB",
    des_code: "RAK ;16429",
  },
  {
    dep_code: "DUB",
    des_code: "MAH ;14267",
  },
  {
    dep_code: "DUB",
    des_code: "MXP ;14456",
  },
  // {
  //   dep_code: "DUB",
  //   des_code: "JMK ;13294",
  // },
  {
    dep_code: "DUB",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "DUB",
    des_code: "PMI ;15634",
  },
  {
    dep_code: "DUB",
    des_code: "PFO ;15508",
  },
  // {
  //   dep_code: "DUB",
  //   des_code: "PUY ;15820",
  // },
  {
    dep_code: "DUB",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "DUB",
    des_code: "FCO ;16607",
  },
  {
    dep_code: "DUB",
    des_code: "JTR ;32620",
  },
  {
    dep_code: "DUB",
    des_code: "SPU ;17080",
  },
  {
    dep_code: "DUB",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "DUB",
    des_code: "VCE ;17968",
  },
  {
    dep_code: "DUB",
    des_code: "VRN ;18074",
  },
  {
    dep_code: "DUB",
    des_code: "ZTH ;19290",
  },
  // {
  //   dep_code: "DUB",
  //   des_code: "ADB ;13205",
  // },

  //ORK
  // {
  //   dep_code: "ORK",
  //   des_code: "AGA ;10271",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "BJV ;11166",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "CFU ;32612",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "HER ;32613",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "DLM ;11828",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "DBV ;11739",
  // },
  {
    dep_code: "ORK",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "ORK",
    des_code: "FUE ;12354",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "FNC ;12286",
  // },
  {
    dep_code: "ORK",
    des_code: "LPA ;14104",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "SKG ;32614",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "IBZ ;12987",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "KGS ;13484",
  // },
  {
    dep_code: "ORK",
    des_code: "ACE ;10218",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "LCA ;13894",
  // },
  {
    dep_code: "ORK",
    des_code: "AGP ;10284",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "MLA ;14516",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "RAK ;16429",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "MAH ;14267",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "MXP ;14456",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "JMK ;13294",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "NAP ;14879",
  // },
  {
    dep_code: "ORK",
    des_code: "PMI ;15634",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "PFO ;15508",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "PUY ;15820",
  // },
  {
    dep_code: "ORK",
    des_code: "RHO ;16534",
  },
  {
    dep_code: "ORK",
    des_code: "FCO ;16607",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "JTR ;32620",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "SPU ;17080",
  // },
  {
    dep_code: "ORK",
    des_code: "TFS ;17368",
  },
  {
    dep_code: "ORK",
    des_code: "VCE ;17968",
  },
  // {
  //   dep_code: "ORK",
  //   des_code: "ADB ;13205",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "VRN ;18074",
  // },
  // {
  //   dep_code: "ORK",
  //   des_code: "ZTH ;19290",
  // },

  // SNN
  // {
  //   dep_code: "SNN",
  //   des_code: "AGA ;10271",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "BJV ;11166",
  // },
  {
    dep_code: "SNN",
    des_code: "CFU ;32612",
  },
  // {
  //   dep_code: "SNN",
  //   des_code: "HER ;32613",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "DLM ;11828",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "DBV ;11739",
  // },
  {
    dep_code: "SNN",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "SNN",
  //   des_code: "FLR ;12270",
  // },
  {
    dep_code: "SNN",
    des_code: "FUE ;12354",
  },
  {
    dep_code: "SNN",
    des_code: "FNC ;12286",
  },
  {
    dep_code: "SNN",
    des_code: "LPA ;14104",
  },
  // {
  //   dep_code: "SNN",
  //   des_code: "SKG ;32614",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "IBZ ;12987",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "KGS ;13484",
  // },
  {
    dep_code: "SNN",
    des_code: "ACE ;10218",
  },
  // {
  //   dep_code: "SNN",
  //   des_code: "LCA ;13894",
  // },
  {
    dep_code: "SNN",
    des_code: "AGP ;10284",
  },
  {
    dep_code: "SNN",
    des_code: "MLA ;14516",
  },
  // {
  //   dep_code: "SNN",
  //   des_code: "RAK ;16429",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "MAH ;14267",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "MXP ;14456",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "JMK ;13294",
  // },
  {
    dep_code: "SNN",
    des_code: "NAP ;14879",
  },
  {
    dep_code: "SNN",
    des_code: "PMI ;15634",
  },
  // {
  //   dep_code: "SNN",
  //   des_code: "PFO ;15508",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "PUY ;15820",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "RHO ;16534",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "FCO ;16607",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "JTR ;32620",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "SPU ;17080",
  // },
  {
    dep_code: "SNN",
    des_code: "TFS ;17368",
  },
  // {
  //   dep_code: "SNN",
  //   des_code: "VCE ;17968",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "VRN ;18074",
  // },
  // {
  //   dep_code: "SNN",
  //   des_code: "ZTH ;19290",
  // },

  // NOC
  // {
  //   dep_code: "NOC",
  //   des_code: "AGA ;10271",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "AYT ;10628",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "BJV ;11166",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "CFU ;32612",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "HER ;32613",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "DLM ;11828",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "DBV ;11739",
  // },
  {
    dep_code: "NOC",
    des_code: "FAO ;12196",
  },
  // {
  //   dep_code: "NOC",
  //   des_code: "FLR ;12270",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "FUE ;12354",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "FNC ;12286",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "LPA ;14104",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "SKG ;32614",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "IBZ ;12987",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "KGS ;13484",
  // },
  {
    dep_code: "NOC",
    des_code: "ACE ;10218",
  },
  // {
  //   dep_code: "NOC",
  //   des_code: "LCA ;13894",
  // },
  {
    dep_code: "NOC",
    des_code: "AGP ;10284",
  },
  // {
  //   dep_code: "NOC",
  //   des_code: "MLA ;14516",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "RAK ;16429",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "MAH ;14267",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "MXP ;14456",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "JMK ;13294",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "NAP ;14879",
  // },
  {
    dep_code: "NOC",
    des_code: "PMI ;15634",
  },
  // {
  //   dep_code: "NOC",
  //   des_code: "PFO ;15508",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "PUY ;15820",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "RHO ;16534",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "FCO ;16607",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "JTR ;32620",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "SPU ;17080",
  // },
  {
    dep_code: "NOC",
    des_code: "TFS ;17368",
  },
  // {
  //   dep_code: "NOC",
  //   des_code: "VCE ;17968",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "VRN ;18074",
  // },
  // {
  //   dep_code: "NOC",
  //   des_code: "ZTH ;19290",
  // },

];
